<template>
	<div class="user_completeInfo">
		<!-- 公共头部 -->
		<div class="per-line-40 black top-box">
			<div class="fl">歡迎來到香港中國企業協會</div>
			<div class="fr">
				<span v-if="$store.state.userName === ''">未登錄</span>
				<span v-else>歡迎 <span class="blue">{{ $store.state.userName }}</span> <span @click="exitAccount()" class="c">退出</span></span>
				<span class="c mar-lef-15" @click="goArticleDetail(2)">關於我們</span>
				<span @click="goArticleDetail(3)" class="mar-lef-15 c">聯系我們</span>
			</div>
		</div>
		<div class="pos-relative" style="height: 272px; ">
			<img src="static/img/banner1.jpg" class="banner-box" height="272" style="opacity: 0.4; ">
			<div class="pos-absolute" style="width: 500px; left: 10%; top: 45px;">
				<img src="static/img/logo.png" class="pos-absolute banner-box-logo width-100per">
			</div>
			<!-- 导航栏 -->
			<div class="per-line-50 red-b pos-absolute font-size-16 white width-100per" style="bottom: 10px;">
				<div style="width: 1200px; margin: 0 auto; " class="over-hidden">
					<div class="fl per-line-50 ellip tl c white" @click="goShopIndex()">首頁</div>
					<mu-menu class="fl per-line-50 tl c over-hidden white" style=" margin-left: 50px;" placement="bottom-start" open-on-hover :key="i" v-for="(category, i) in categorys">
						<div style="background-color: transparent;" class="fl per-line-50 ellip tl c white">{{ category.title }}</div>
						<mu-list slot="content" class="red-b white" :key='j' v-for="(categoryChild, j) in category.child">
							<mu-list-item button @click="goSortIndex(categoryChild.id, categoryChild.title)">
								<mu-list-item-title class="white">{{ categoryChild.title }}</mu-list-item-title>
							</mu-list-item>
						</mu-list>
					</mu-menu>
				</div>
			</div>
		</div>
		<!-- 公共头部 -->
		<div v-show="!showTemplate" class="over-hidden white-b pad-lef-15 pad-bot-15" style="width: 1200px; margin: 15px auto 0;">
			<!-- 最外层左边一栏 -->
			<div class="width-50per fl white-b">
				<div class="per-big-cell til mar-top-15 over-hidden">
					<div v-html='contextAll' class="tl"></div>
				</div>
			</div>
			<div class="fl mar-lef-2per width-48per">
				<div class="per-little-cell white-b">
					<div class="per-line-30 white orange-b tl pad-lef-15">申請入會</div>
					<div class="white-b tl pad-15">
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">用戶名</span>
							<span class="fl input-style width-48per mar-lef-2per">{{ username }}</span>
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">申請人</span>
							<input type="text" v-model="applicant" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">性別</span>
							<select v-model="sex" class="fl input-style width-48per mar-lef-2per">
								<option value="1">男</option>
								<option value="2">女</option>
							</select>
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">通訊地址</span>
							<input type="text" placeholder="中文" v-model="ch_address" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">通訊地址</span>
							<input type="text" placeholder="英文" v-model="en_address" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">Tel</span>
							<input type="text" v-model="tel" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">Fax</span>
							<input type="text" v-model="fax" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">E-Mail</span>
							<input type="text" v-model="email" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">現職單位</span>
							<input type="text" v-model="xianzhi_unit" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">股東單位</span>
							<input type="text" v-model="gudong_unit" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">持股比例</span>
							<input type="text" v-model="chigu_rate" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">職位</span>
							<input type="text" v-model="job" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">主要業務</span>
							<input type="text" v-model="main_business" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="height-50 mar-top-5 over-hidden">
							<span class="width-30per fl tr ellip per-line-50">何時來港工作</span>
							<mu-date-input :underlineShow="false" class="fl width-48per height-50 mar-lef-2per border-1" v-model="gotime" :solo='true' format="YYYY-MM-DD"></mu-date-input>
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">由何地來港</span>
							<input type="text" v-model="wherefrom" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">最後畢業院校</span>
							<input type="text" v-model="graduate_shcool" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">獲得學位</span>
							<input type="text" v-model="degree" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">專業</span>
							<input type="text" v-model="major" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">內地最後任職機構或就讀學校</span>
							<input type="text" v-model="last_work_in" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">內地永久通訊地址</span>
							<input type="text" v-model="forever_address" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">本人專長</span>
							<input type="text" v-model="skill" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 ellip mar-top-5">
							<span class="width-30per fl tr ellip">對協會的期望</span>
							<input type="text" v-model="expect" class="fl input-style width-48per mar-lef-2per">
						</div>
						<div class="per-line-30 tc red-b-opacity c white width-100" style="margin: 5px auto 0;" @click="complete()">申請入會</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="showTemplate" class="over-hidden white-b pad-15">
			<div class="tl">
				本人承認香港中國企業協會章程﹐並遵守有關管理規定﹐現申請加入香港中國企業協會。請審議。
			</div>
			<div class="tl mar-top-50">請一併附上以下材料：</div>
			<div class="tl">1.本人有效身分證複印件一份。</div>
			<div class="tl">2.本人之名片一張。</div>
			<div class="tl">3.本人2吋半身正面近照兩張。</div>
			<div class="tl">4.本人簡歷一份。</div>
			<div class="tl">5.港幣貳仟捌佰元劃線支票一張(入會費HK$2000.00＋當年年費HK$800.00)﹐支票抬頭：香港中國企業協會。</div>
			<div @click="index()" class="tl mar-top-20 per-line-30 tc red-b-opacity white width-100 c">確定</div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'user_completeInfo',
	data () {
		return {
			selectI: 0,
			navs: [],
			guide_id: 1,
			contextAll: '',
			applicant: '',
			type: 1,
			sex: '1',
			ch_address: '',
			en_address: '',
			tel: '',
			fax: '',
			email: '',
			xianzhi_unit: '',
			gudong_unit: '',
			chigu_rate: '',
			job: '',
			main_business: '',
			gotime: '',
			wherefrom: '',
			graduate_shcool: '',
			degree: '',
			major: '',
			last_work_in: '',
			forever_address: '',
			skill: '',
			expect: '',
			showTemplate: false,
			username: '',

			categorys: [],
		}
	},
	created () {

	},
	mounted () {
		let that = this
		that.c_ajax({}, 'api.php/CmsCategory/lists', function (value) {
			for (let v of value.data) {
				if (v.id !== 1 && v.id !== 2 && v.id !== 147) {
					that.categorys.push(v)
				}
			}
		})
		that.getAllDetail(this.guide_id)
		that.c_ajax({user_id: that.$store.state.user_id }, 'api.php/User/detail', function (value) {
			if (value.data.status === 10001) {
				let obj = value.data.detail
				that.username = obj.username
				that.sex = obj.sex
				that.applicant = obj.applicant
				that.ch_address = obj.ch_address
				that.en_address = obj.en_address
				that.tel = obj.tel
				that.fax = obj.fax
				that.email = obj.email
				that.xianzhi_unit = obj.xianzhi_unit
				that.gudong_unit = obj.gudong_unit
				that.chigu_rate = obj.chigu_rate
				that.job = obj.job
				that.main_business = obj.main_business
				that.gotime = '2000-01-01'
				that.wherefrom = obj.wherefrom
				that.graduate_shcool = obj.graduate_shcool
				that.degree = obj.degree
				that.major = obj.major
				that.last_work_in = obj.last_work_in
				that.forever_address = obj.forever_address
				that.skill = obj.skill
				that.expect = obj.expect
			} else {
				that.showDialog(value.data.msg)
			}
		})
	},
	methods: {
		//获取主页 文章标题对应的内容 左边会全空
		getAllDetail (id) {
			let that = this
			that.c_ajax({id: id,}, 'api.php/Cms/detail', function (value) {
				if (value.data.status === 10001) {
					that.contextAll = value.data.detail.context
				}
			})
		},
		complete () {
			let that = this
			if (!this.applicant) {
				that.showDialog('申請人不能為空!')
				return
			}
			if (!this.sex) {
				that.showDialog('性別不能為空!')
				return
			}
			if (!this.ch_address) {
				that.showDialog('通訊地址不能為空!')
				return
			}
			if (!this.en_address) {
				that.showDialog('通訊地址不能為空!')
				return
			}
			if (!this.fax) {
				that.showDialog('傳真不能為空!')
				return
			}
			if (!this.xianzhi_unit) {
				that.showDialog('現職單位不能為空!')
				return
			}
			if (!this.gudong_unit) {
				that.showDialog('股東單位不能為空!')
				return
			}
			if (!this.chigu_rate) {
				that.showDialog('持股比例不能為空!')
				return
			}
			if (!this.job) {
				that.showDialog('職位不能為空!')
				return
			}
			if (!this.main_business) {
				that.showDialog('主要業務不能為空!')
				return
			}
			if (!this.gotime) {
				that.showDialog('何時來港工作不能為空!')
				return
			}
			if (!this.wherefrom) {
				that.showDialog('由何地來港不能為空!')
				return
			}
			if (!this.graduate_shcool) {
				that.showDialog('最後畢業院校不能為空!')
				return
			}
			if (!this.degree) {
				that.showDialog('獲得學位不能為空!')
				return
			}
			if (!this.major) {
				that.showDialog('專業不能為空!')
				return
			}
			if (!this.last_work_in) {
				that.showDialog('內地最後任職機構或就讀學校不能為空!')
				return
			}
			if (!this.forever_address) {
				that.showDialog('內地永久通訊地址不能為空!')
				return
			}
			if (!this.skill) {
				that.showDialog('本人專長不能為空!')
				return
			}
			if (!this.expect) {
				that.showDialog('對協會的期望不能為空!')
				return
			}
			let post = {
				applicant: this.applicant, sex: this.sex, ch_address: this.ch_address, en_address: this.en_address, tel: this.tel, fax: this.fax, email: this.email, xianzhi_unit: this.xianzhi_unit, gudong_unit: this.gudong_unit, chigu_rate: this.chigu_rate, job: this.job, main_business: this.main_business, gotime: new Date(this.gotime).getTime(), wherefrom: this.wherefrom, graduate_shcool: this.graduate_shcool, degree: this.degree, major: this.major, last_work_in: this.last_work_in, forever_address: this.forever_address, skill: this.skill, expect: this.expect, type: this.type,
			}
			that.c_ajax({post: post}, 'api.php/User/update', function (value) {
				that.showDialog('成功申請入會，等待管理員審核!')
				setTimeout(function () {
					that.showTemplate = true
					that.$store.commit('updateIsRuHui', {isRuHui: 1, })
					that.setLocalObj('xianggangzhongxie', {
						token: that.getLocalObj('xianggangzhongxie').token,
						token_time: that.getLocalObj('xianggangzhongxie').token_time,
						user_id: that.getLocalObj('xianggangzhongxie').user_id,
						userType: that.getLocalObj('xianggangzhongxie').userType,
						isRuHui: 1,
						hasQiYe: that.getLocalObj('xianggangzhongxie').hasQiYe,
						isShenHe: that.getLocalObj('xianggangzhongxie').isShenHe,
					})
				}, 1500)
			})
		},
	},
}
</script>

<style scoped>
.user_completeInfo {
}
.input-style {
	display: inline-block;
	height: 28px;
	outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/user_completeInfo.vue